import plData from './pl/index.js'
import enData from './en/index.js'

export default {
    'pl': plData,
    'en': enData
}